import { useEffect } from 'react'
import HeaderImage from '../../assets/header3.png'
import data from './data'
import AOS from 'aos'
import 'aos/dist/aos.css'
import './header.css'

const Header = () => {
  useEffect(() => {
    AOS.init({duration: 2000})
  }, [])

  return (
    <header id="header">
      <div className="container header__container">
        <div className="header__profile" data-aos="fade-in">
          <img src={HeaderImage} alt="Header Portait" />
        </div>
        <h3  data-aos="fade-up">Manas Telavane</h3>
        {/* <p  data-aos="fade-up"> */}
        <p align="center">
          <img src="https://readme-typing-svg.demolab.com/?lines=A+Compititive+Programmer!;A+Full+Stack+Web+Developer!;A+Open+Source+Contributor!&font=Fira%20Code&center=true&width=380&height=50&duration=4000&pause=1000" alt="nothing"/>
        </p>
        {/* </p> */}
        <div className="header__cta"  >
          <a href="#contact" className='btn primary'>Let's Talk</a>
          <a href="#portfolio" className='btn light'>My Work</a>
        </div>
        <div className="header__socials">
          {
            data.map(item => <a key={item.id} href={item.link} target="_blank" rel="noopener noreferrer">{item.icon}</a>)
          }
        </div>
      </div>
    </header>
  )
}

export default Header